const SERVER_URL = window.location.origin === 'https://integrador.smarteklife.com'
  ? 'https://api.smarteklife.com'
  : 'http://localhost:3030';

export default SERVER_URL;
